import type { ReactElement } from 'react';
import { Button, Divider, Space } from 'antd';

/**
 * Низ выпадающего списка поля «участник» на несколько человек: «Добавить всех»
 * выбирает всех участников из списка, «Снять всех» очищает поле.
 *
 * Кнопки гасят mousedown, чтобы Select не терял фокус — иначе список
 * закрывается раньше, чем дойдёт клик.
 */
export function renderUserBulkPopup(
  menu: ReactElement,
  allUserIds: string[],
  selected: unknown,
  onChange: (next: string[]) => void,
): ReactElement {
  const selectedCount = Array.isArray(selected) ? selected.length : 0;
  const allSelected =
    allUserIds.length > 0 &&
    allUserIds.every((id) => Array.isArray(selected) && selected.includes(id));
  return (
    <>
      {menu}
      <Divider style={{ margin: '4px 0' }} />
      <Space style={{ padding: '0 8px 4px' }} size={4}>
        <Button
          size="small"
          type="link"
          disabled={allUserIds.length === 0 || allSelected}
          onMouseDown={(e) => e.preventDefault()}
          // Уже выбранных, но выбывших из пространства не теряем.
          onClick={() =>
            onChange([
              ...new Set([...(Array.isArray(selected) ? selected.map(String) : []), ...allUserIds]),
            ])
          }
        >
          Добавить всех
        </Button>
        <Button
          size="small"
          type="link"
          disabled={selectedCount === 0}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onChange([])}
        >
          Снять всех
        </Button>
      </Space>
    </>
  );
}
